import { OAuthModuleConfig } from 'angular-oauth2-oidc';

export function getApiConfig<T extends Record<keyof T, string>>(
  apiConfig: T,
): T & Record<'authModuleConfig', OAuthModuleConfig> {
  return {
    ...apiConfig,
    authModuleConfig: {
      resourceServer: {
        allowedUrls: Object.values(apiConfig),
        sendAccessToken: true,
      },
    },
  };
}
